import http from '../http'
import { Res } from '../type'
import {
  GoodsApplyReq,
  goodsDetailResp,
  GoodsRequestModel,
  GoodsResponseModel
} from '@/model/score/GoodsModel'
import {
  bankListResp,
  chargeRecordsResp,
  confirmImageProp,
  MaterialRedeemDetailResp,
  MaterialRedeemResp,
  myScoreReq,
  mySocreResp,
  pointsRechargeDetailModel,
  RemittanceReq,
  scoreRecordsModel,
  uploadResp
} from '@/model/score/score'
//物料分页列表
export const getGoodsList = (
  data: GoodsRequestModel
  // config: { loadingShow: '0' | '1' }
): Res<GoodsResponseModel> => {
  return http.request({
    url: '/material/queryMaterialByPage',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//物料详情
export const getGoodsDetail = (
  data: { salesPriceId: string }
  // config: { loadingShow: '0' | '1' }
): Res<goodsDetailResp> => {
  return http.request({
    url: '/material/queryMaterialDetail',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//积分信息
export const getMyScore = (data: myScoreReq): Res<mySocreResp> => {
  return http.request({
    url: '/pointsAccount/detail',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//物料申请
export const goodsApply = (data: GoodsApplyReq): Res<void> => {
  return http.request({
    url: '/material/apply',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}

//兑换记录
export const scoreRecords = (
  data: scoreRecordsModel
): Res<MaterialRedeemResp> => {
  return http.request({
    url: '/material/page',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//兑换记录详情
export const scoreRecordsDetail = (data: {
  id: string
}): Res<MaterialRedeemDetailResp> => {
  return http.request({
    url: '/material/detail',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}

//充值记录
export const chargeRecords = (
  data: scoreRecordsModel
): Res<chargeRecordsResp> => {
  return http.request({
    url: '/pointsRecharge/page',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//确认送达上传图片
export const confirmDelivery = (data: confirmImageProp): Res<void> => {
  return http.request({
    url: '/material/confirmDelivery',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}

//取消兑换
export const cancelExchange = (data: { id: string }): Res<void> => {
  return http.request({
    url: '/material/cancelExchange',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//取消兑换
export const arrived = (data: { id: string }): Res<void> => {
  return http.request({
    url: '/material/confirmDelivery',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//充值记录详情以及进度
export const pointsRechargeDetail = (data: {
  id: string
}): Res<pointsRechargeDetailModel> => {
  return http.request({
    url: '/pointsRecharge/detail',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//银行列表
export const bankList = (dictCode = 'Openingbank'): Res<bankListResp> => {
  return http.request({
    url: '/dict-value/getDictValue',
    method: 'post',
    data: { current: 1, dictCode, size: 100 },
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
//充值接口
export const Remittance = (data: RemittanceReq): Res<void> => {
  return http.request({
    url: '/pointsRecharge/recharge',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
// 上传图片
export const imageUpload = (data: FormData): Res<uploadResp> => {
  return http.request({
    url: '/architecture/upload',
    method: 'post',
    data,
    loadingShow: '0',
    header: { 'Content-Type': 'multipart/form-data' }
    // loadingShow: config.loadingShow
  })
}
